import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";
import { createRequestState, requestFailed, requestStarted, requestSucceeded } from "./requestState";

const slice = createSlice({
  name: "layoutUI",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    pageTitle: "",
    route: [],
    alertMessages: [],
    helpDocs: null,
    requests: {
      alertMessages: createRequestState(),
      helpDocs: createRequestState(),
    },
  },
  reducers: {
    layoutRequestStarted: (layoutUI, action) => {
      requestStarted(layoutUI.requests, action.payload);
      layoutUI.loading = true;
    },
    layoutRequestFailed: (layoutUI, action) => {
      requestFailed(layoutUI.requests, action.payload?.key, action.payload?.error || action.payload);
      layoutUI.loading = false;
    },
    setCurrentPageTitle: (layoutUI, action) => {
      layoutUI.pageTitle = action.payload;
    },
    setCurrentRoute: (layoutUI, action) => {
      layoutUI.route = action.payload;
    },
    ruleAppDataReceived: (layoutUI, action) => {
      layoutUI.ruleAppData = action.payload;
    },
    alertMessagesReceived: (layoutUI, action) => {
      layoutUI.alertMessages = [...action.payload, ...layoutUI.alertMessages];
      layoutUI.loading = false;
      requestSucceeded(layoutUI.requests, "alertMessages");
    },
    helpDocsReceived: (layoutUI, action) => {
      layoutUI.helpDocs = action.payload;
      layoutUI.loading = false;
      requestSucceeded(layoutUI.requests, "helpDocs");
    },
  },
});

export const {
  layoutRequestStarted,
  layoutRequestFailed,
  setCurrentPageTitle,
  setCurrentRoute,
  alertMessagesReceived,
  helpDocsReceived,
} = slice.actions;
export default slice.reducer;

// export const loadButtonAlertMessages = (id) => apiCallBegan({
//     url: config.GetFormProcessItems + id,
//     onSuccess: alertMessagesReceived.type
// });

export const loadAllButtonAlertMessages = (ids) =>
  apiCallBegan({
    url: config.GetFormAllProcessItems,
    method: "post",
    data: ids,
    onStart: { type: layoutRequestStarted.type, payload: "alertMessages" },
    onSuccess: alertMessagesReceived.type,
    onError: { type: layoutRequestFailed.type, payload: { key: "alertMessages" } },
    cancelPrevious: true,
    cancelKey: "layoutUI/alertMessages",
  });

export const loadWorkbenchHelpDocs = (id, forceRefresh = true) =>
  apiCallBegan({
    url: config.GetHelpDocs + id,
    //responseType: "blob",
    onStart: { type: layoutRequestStarted.type, payload: "helpDocs" },
    onSuccess: helpDocsReceived.type,
    onError: { type: layoutRequestFailed.type, payload: { key: "helpDocs" } },
    cache: false,
    forceRefresh,
  });

export const getPageTitle = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.pageTitle,
);

export const getPageRoute = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.route,
);

export const getButtonAlertMessages = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.alertMessages,
);

export const getWorkbenchHelpDocs = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.helpDocs,
);

export const getLayoutRequests = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.requests,
);
